'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValidatorFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assert = require('./assert');

var assert = _interopRequireWildcard(_assert);

var _libphonenumberJs = require('libphonenumber-js');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Helpful function to inn validator
 * @param inn
 * @param offset
 * @param arrOffset
 * @returns {boolean}
 */
function checkInnStep(inn, offset, arrOffset) {
    var CHECK_ARRAY = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

    var sum = 0;
    var length = inn.length;
    for (var i = 0; i < length - offset; i++) {
        sum += parseInt(inn[i], 10) * CHECK_ARRAY[i + arrOffset];
    }

    return sum % 11 % 10 === parseInt(inn[length - offset], 10);
}

function t(key) {
    return key;
}

var OK_VALIDATION_RESULT = true;
var FAILED_VALIDATION_RESULT = false;
var UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
var INN_PATTERN = /\d{10}(?:\d{2})?/i;
var EMAIL_PATTERN = /^[-a-zа-яё0-9~!$%^&*_=+}{\'?]+(\.[-a-zа-яё0-9~!$%^&*_=+}{\'?]+)*@(([a-zа-яё0-9_][-a-zа-яё0-9_]*(\.[-a-zа-яё0-9_]+)*\.(([а-яё]{2,})|([a-z]{2,})|(xn--[a-z0-9]+)))|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
var ONE_DIGIT_PATTERN = /[0-9]/;
var ONE_LOWERCASE_LETTER_PATTERN = /[a-z]/;
var ONE_UPPERCASE_LETTER_PATTERN = /[A-Z]/;
var URL_PATTERN = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?\'\\+&%$#=~_-]+))*$/i;
var BIC_PATTERN = /[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?/;

function isValidInn(value) {
    var inn = value.trim();

    if (!INN_PATTERN.test(inn)) {
        return false;
    }
    var length = inn.length;
    if (length === 12) {
        return checkInnStep(inn, 2, 1) && checkInnStep(inn, 1, 0);
    }

    if (length === 10) {
        return checkInnStep(inn, 1, 2);
    }

    return false;
}

/**
 * All standard client-side validators use namespace `validator` for i18next-translation
 */
function errorWithNamespace(error) {
    var extendedError = Object.assign({}, error);
    extendedError.details = Object.assign({
        ns: 'validator'
    }, extendedError.details);

    return extendedError;
}

var ValidatorFactory = function () {
    function ValidatorFactory() {
        _classCallCheck(this, ValidatorFactory);
    }

    _createClass(ValidatorFactory, [{
        key: 'notNull',
        value: function notNull() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.notNull');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (value === 0 || value === false || value === '') {
                    return OK_VALIDATION_RESULT;
                }
                if (!value) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'notEmpty',
        value: function notEmpty() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.notEmpty');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value || value.length < 0) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'notBlank',
        value: function notBlank() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.notBlank');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value || value.trim().length <= 0) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'notZeroMoney',
        value: function notZeroMoney() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.notZeroMoney');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(moneyModel) {
                if (!moneyModel) {
                    return OK_VALIDATION_RESULT;
                }

                if (moneyModel.value === 0) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error;

            return validator;
        }
    }, {
        key: 'notNegativeMoney',
        value: function notNegativeMoney() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.notNegativeMoney');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(moneyModel) {
                if (!moneyModel) {
                    return OK_VALIDATION_RESULT;
                }

                if (moneyModel.value < 0) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error;

            return validator;
        }
    }, {
        key: 'uuid',
        value: function uuid() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.uuid');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (!UUID_PATTERN.test(value)) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'email',
        value: function email() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.email');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (!EMAIL_PATTERN.test(value)) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'minLength',
        value: function minLength(min) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.minLength');

            assert.number(min);

            var error = errorWithNamespace({
                message: message,
                details: {
                    min: min
                }
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (value.length < min) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'maxLength',
        value: function maxLength(max) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.maxLength');

            assert.number(max);

            var error = errorWithNamespace({
                message: message,
                details: {
                    max: max
                }
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (value.length > max) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'min',
        value: function min(_min) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.min');

            assert.number(_min);

            var error = errorWithNamespace({
                message: message,
                details: {
                    min: _min
                }
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (value < _min) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'max',
        value: function max(_max) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.max');

            assert.number(_max);

            var error = errorWithNamespace({
                message: message,
                details: {
                    max: _max
                }
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (value > _max) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'pattern',
        value: function pattern(_pattern) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.pattern');

            assert.string(_pattern);

            var error = errorWithNamespace({
                message: message,
                details: {
                    pattern: _pattern
                }
            });

            var patterRegex = new RegExp(_pattern);

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (!patterRegex.test(value)) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'inn',
        value: function inn() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.inn');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (!isValidInn(value)) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'bic',
        value: function bic() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.bic');

            var error = errorWithNamespace({ message: message });

            var validator = function validator(value) {
                return !value || BIC_PATTERN.test(value.trim());
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'oneOf',
        value: function oneOf(variants) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.oneOf');

            assert.array(variants);

            var error = errorWithNamespace({
                message: message,
                substitutions: {
                    variants: variants
                }
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (variants.indexOf(value) === -1) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'validCurrency',
        value: function validCurrency(availableCurrencies) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.validCurrency');

            assert.array(availableCurrencies);

            var error = errorWithNamespace({
                message: message,
                substitutions: {
                    availableCurrencies: availableCurrencies
                }
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (availableCurrencies.indexOf(value.currency) === -1) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'validPassword',
        value: function validPassword() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.validPassword');


            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (!ONE_DIGIT_PATTERN.test(value) || !ONE_LOWERCASE_LETTER_PATTERN.test(value) || !ONE_UPPERCASE_LETTER_PATTERN.test(value)) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }

        /**
         * For files array only!
         */

    }, {
        key: 'maxSummaryFileSize',
        value: function maxSummaryFileSize(max) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.maxSummaryFileSize');

            assert.number(max);

            var error = errorWithNamespace({
                message: message,
                details: {
                    max: max
                }
            });

            var validator = function validator(files) {
                if (!files || files.length === 0) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                var actualSize = files.reduce(function (result, _ref) {
                    var size = _ref.size;
                    return result + size;
                }, 0);

                if (actualSize > max) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'supportedFormats',
        value: function supportedFormats(formats) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('validator.supportedFormats');

            assert.array(formats);

            var error = errorWithNamespace({
                message: message,
                details: {
                    formats: formats
                }
            });

            var validator = function validator(file) {
                if (!file) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                var fileNameArray = file.name.split('.');
                var extension = fileNameArray[fileNameArray.length - 1];
                if (formats.indexOf(extension) === -1) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'phone',
        value: function phone() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.phone');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value) {
                    // skip null validation
                    return OK_VALIDATION_RESULT;
                }

                if (!(0, _libphonenumberJs.isValidNumber)(value)) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }, {
        key: 'url',
        value: function url() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t('validator.url');

            var error = errorWithNamespace({
                message: message
            });

            var validator = function validator(value) {
                if (!value) {
                    return OK_VALIDATION_RESULT;
                }

                if (!URL_PATTERN.test(value)) {
                    return FAILED_VALIDATION_RESULT;
                }

                return OK_VALIDATION_RESULT;
            };

            validator.message = error; // todo(FVENDOR-5081): remove

            return validator;
        }
    }]);

    return ValidatorFactory;
}();

exports.ValidatorFactory = ValidatorFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/aurora-javascript-utils/dist/ValidatorFactory.js
// module id = 722
// module chunks = 118